export default {
  DATE_DEFAULT_START_DATE: '1111-01-01 00:00:00+00',
  DATE_DEFAULT_END_DATE: '9999-09-09 12:59:59+00'
}
